import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 100%;
  height: -webkit-fill-available;
  height: -moz-fill-available;
  overflow: hidden;
  box-sizing: border-box;
  background-color: ${props => props.theme.background};
`

export const Content = styled.div`
  overflow: hidden;
  height: 100%;
  height: -webkit-fill-available;
  height: -moz-fill-available;
`
